import { BackgroundColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const CompanySettingsContainer = styled.div`
	margin-top: 0;
`;

const Box = styled.div`
	padding: 24px;
	background-color: ${BackgroundColors.PrimaryAlt};
	border-radius: ${BorderRadius.XL}px;
`;

const NoteWrapper = styled.div`
	margin-top: 0;
`;

const NoteContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

const CompanyCommentContainer = styled.div`
	padding: 16px;
	background-color: ${BackgroundColors.PrimaryAlt};
	border-radius: ${BorderRadius.MD}px;
`;

const CompanyInternalNote = styled.div`
	padding: 16px;
	background-color: ${BackgroundColors.PrimaryAlt};
	border-radius: ${BorderRadius.MD}px;
`;

const CircularFlag = styled.div`
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export {
	CompanySettingsContainer,
	Box,
	NoteWrapper,
	NoteContainer,
	CompanyCommentContainer,
	CompanyInternalNote,
	CircularFlag,
};
